import React, { useEffect, useState } from "react";
import qs from "qs";
import { Navigate, useParams } from "react-router-dom";
import { socketFunc } from "../../../../utils/socketUtil";
import { Toaster } from "../../../../utils/toaster";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Loader from "../../../../assets/images/loader1.webp";

const DynamicGames = ({ customProvider = null }) => {
  const { provider: pd } = useParams();
  const provider = customProvider || pd;
  const token = localStorage.getItem("token");
  const socket = socketFunc(token);
  const [iframeUrl, setIframeUrl] = useState("");

  useEffect(() => {
    const decodedParams = decodeURIComponent(window.location.href);
    const parsedValues = qs.parse(decodedParams.split("?")?.[1] || "");
    getLobby(parsedValues);
  }, [provider, token]);

  const getLobby = (params) => {
    socket.emit(
      "get:sports_lobby",
      {
        providerCode: provider?.toUpperCase(),
        ...params,
      },
      (res) => {
        if (res?.status === "failed") {
          Toaster.Error(res?.message || "Failed to get");
        }
        if (res?.status === "success") {
          handleResponse(res);
        }
      },
    );
  };

  const handleResponse = (value) => {
    if (value?.data && typeof value?.data === "string") {
      setIframeUrl(value?.data);
    } else if (value?.data && "lobbyUrl" in value?.data?.data) {
      setIframeUrl(value?.data?.data?.lobbyUrl);
    } else {
      setIframeUrl("");
    }
  };

  return (
    <div className="live_casino_page live">
      <div className="header-bg">
        <HeaderAfterLogin />
      </div>
      {/* <div className="d-xl-none">
          <LeftBarSports />
        </div> */}
      <main className="main">
        <div className="live_casino_page live">
          {!Boolean(iframeUrl) ? (
            <div className="geme-loader">
              <img src={Loader} alt="loader" />
            </div>
          ) : iframeUrl === "notAllowed" ? (
            <Navigate to="/home" />
          ) : iframeUrl === "notFound" ? (
            <Navigate to="/home" />
          ) : (
            <div className="exchange_iframe">
              <iframe
                title="Exchange"
                src={iframeUrl}
                frameBorder="0"
                style={{
                  width: "100%",
                  height: "calc(100vh - 70px)",
                }}
                // scrolling="no"
                allowFullScreen={true}
              >
                Your browser doesn't support iFrames.
              </iframe>
            </div>
          )}
          {/*  Iframe End */}
        </div>
      </main>

      <div>{/* <BottomNav /> */}</div>
    </div>
  );
};
export default DynamicGames;
